<template>
  <bscroll-view>
    <div class="knowledge-content">
      <div class="content-body">
        <div
          v-if="knowledgeBg != ''"
          class="search-wrap"
          :style="{ 'background-image': `url('${knowledgeBg}')` }"
        >
          <!-- <div class="search-content">
            <img src="@/assets/img/search-glass.png" />
            <input
              type="text"
              :placeholder="langTransfer('请输入内容，按回车搜索')"
            />
          </div> -->
        </div>
        <section
          v-for="(item, index) in listData"
          :key="index"
          class="knowledge-group"
        >
          <h5 class="name">
            {{ langTransfer(item.name) }}
          </h5>
          <div class="knowledge-subs">
            <div
              v-for="(sub, i) in item.child"
              :key="i"
              class="sub-item"
              @click="itemClick(sub)"
            >
              <img :src="sub.poster" />
              <div class="name text1line">
                {{ langTransfer(sub.name) }}
              </div>
            </div>
            <div class="sub-item hb-spacebeteen-empty" />
            <div class="sub-item hb-spacebeteen-empty" />
            <div class="sub-item hb-spacebeteen-empty" />
            <div class="sub-item hb-spacebeteen-empty" />
            <div class="sub-item hb-spacebeteen-empty" />
          </div>
        </section>
      </div>
      <footer-com />
    </div>
  </bscroll-view>
</template>

<script>
import { getKonwledgeList } from "@/api/hb";
import BscrollView from "@/components/bscrollView";
import FooterCom from "@/components/footerCom/footerCom";

// const mainBgDefault = require("@/assets/img/knowledge-bg.jpeg");
const mainBgDefault = "";

export default {
  name: "Knowledge",
  components: {
    FooterCom,
    BscrollView,
  },
  data() {
    return {
      listData: [],
    };
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
    knowledgeBg() {
      const { upperPart } = this.$store.state;
      if (!upperPart.enableModuleList) {
        return mainBgDefault;
      }

      const result = upperPart.enableModuleList.find((e) => {
        return e.type === 2;
      });

      return result && result.poster ? result.poster : mainBgDefault;
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.getKonwledgeList();
      }
    },
  },
  created() {},
  methods: {
    itemClick(item) {
      const { href } = this.$router.resolve({
        name: "knowledgeLibDetail",
        params: {
          id: item.unique_code,
        },
      });
      window.open(href, "_blank");
    },
    async getKonwledgeList() {
      const { service_code } = this.webInfo;
      if (!service_code) {
        return;
      }
      try {
        const data = await getKonwledgeList({
          service_code: this.webInfo.service_code,
          tag: 5,
        });
        this.listData = data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.getKonwledgeList();
      }
    });
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .knowledge-group {
    width: 1296px;
    .sub-item {
      width: 196px;
      height: 87px;
    }
  }
}
@media screen and (max-width: 1280px) {
  .knowledge-group {
    width: 1136px;
    .sub-item {
      width: 169px;
      height: 75px;
    }
  }
}
.knowledge-content {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.content-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.search-wrap {
  width: 100%;
  height: 360px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.search-content {
  width: 720px;
  height: 40px;
  box-sizing: border-box;
  padding: 8px 10px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #cccccc;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    width: 24px;
    height: 24px;
  }

  input {
    flex: 1;
    font-size: 13px;
    font-family: AlibabaPuHuiTiR;
    color: #606266;
  }
}

.knowledge-group {
  // width: 1296px;
  margin-top: 50px;

  &:last-child {
    margin-bottom: 80px;
  }

  .name {
    font-size: 16px;
    font-family: AlibabaPuHuiTiB;
    color: #303133;
    line-height: 16px;
    // font-weight: 600;
    user-select: none;
  }

  .knowledge-subs {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .sub-item {
    border-radius: 8px;
    margin-top: 20px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition: 0.3s;

    &:active {
      transform: scale(0.98);
    }

    &:hover {
      .name {
        background: rgba(0, 0, 0, 0.8);
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .name {
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      line-height: 24px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      // font-weight: 600;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      user-select: none;
      transition: 0.3s;
    }
  }
}
</style>

<style>
.search-content input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
.search-content input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
.search-content input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
.search-content input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
</style>
